<ng-container *ngIf="robotConfig$ | async as roboConfigData">
  <ng-container *ngIf="patternTableData$ | async as patternData">
    <app-page style="margin-bottom: 3em">
      <app-breadcrumb-nav></app-breadcrumb-nav>

      <div class="h1-supertitle">Step 1</div>
      <h1>Selected robot configuration</h1>
      <mat-divider style="padding-bottom: 15px"></mat-divider>

      <!-- RoboConfig Loading state -->
      <app-loading *ngIf="roboConfigData.isLoading"></app-loading>

      <!-- RoboConfig Error state -->
      <app-error
        *ngIf="roboConfigData.error as error"
        [error]="error"
      ></app-error>

      <app-card-robot-config
        *ngIf="roboConfigData.didSucceed"
        [robotConfig]="roboConfigData.value"
        [selected]="true"
      >
      </app-card-robot-config>

      <div class="h1-supertitle">Step 2</div>
      <h1>Select palletizing patterns</h1>
      <mat-divider></mat-divider>

      <!-- Pattern data Loading state -->
      <app-loading *ngIf="patternData.isLoading"></app-loading>

      <!-- Pattern data Error state -->
      <app-error *ngIf="patternData.error as error" [error]="error"></app-error>

      <app-content-switcher
        *ngIf="patternData.didSucceed"
        [enableDelete]="false"
        [enableFiltering]="false"
        [enableSorting]="false"
        [enableToggle]="true"
        [selected]="patternsSelected.selected"
        [sortingColumns]="sortingColumns"
        [setupFilter]="setupFilter"
        [resultFilter]="resultFilter"
        objectType="pattern"
        (order)="orderBy = $event"
        (selectedFiltering)="tableFilter = objUtil.cloneObject($event)"
        defaultMode="card-list"
      >
        <ng-template #table>
          <app-table
            [clickableRows]="true"
            [topRow]="false"
            [inputData]="patternData.value"
            [preSelectedRows]="patternsSelected.selected"
            [displayedColumns]="displayedColumns"
            [actions]="true"
            [filter]="tableFilter"
            [sortBy]="orderBy"
            (rowClicked)="patternRowClicked($event)"
            [showUpdatedAt]="true"
            [existingSelectionModel]="patternsSelected"
          ></app-table>
        </ng-template>

        <ng-template #cardList>
          <app-card-list-wrapper
            [inputData]="patternData.value"
            [filter]="tableFilter"
          >
            <ng-template #card let-data>
              <app-card-pattern-view
                class="card-pattern-default"
                [type]="pickerType"
                [columnColors]="[]"
                [listColumnUnits]="[]"
                [doesAllowActions]="true"
                [data]="data.data"
                [selectedCards]="patternsSelected.selected"
                [cardDetailsData]="cardDetailsData"
                (cardClicked)="patternRowClicked($event)"
              ></app-card-pattern-view>
            </ng-template>
          </app-card-list-wrapper>
        </ng-template>
      </app-content-switcher>
    </app-page>

    <mat-toolbar
      *ngIf="patternData.didSucceed && roboConfigData.didSucceed"
      class="simple-sim-footer"
    >
      <div class="sub-toolbar-layout">
        <!-- Robot configuration name -->
        <div class="sub-toolbar-content-container">
          <div class="sub-toolbar-supertitle">Selected Robot</div>
          <div class="sub-toolbar-content-specified">
            {{ roboConfigData.value.name }}
          </div>
        </div>

        <!-- Pattern name -->
        <div class="sub-toolbar-content-container">
          <div class="sub-toolbar-supertitle">Selected Pattern</div>

          <div
            [ngClass]="
              patternsSelected.selected.length > 0
                ? 'sub-toolbar-content-specified'
                : 'sub-toolbar-content-undefined'
            "
          >
            {{ selectedPatternsTitle }}
          </div>
        </div>

        <!-- CTA buttons -->
        <div class="sub-toolbar-cta">
          <div class="sub-toolbar-cta-button">
            <button
              mat-button
              pally-rounded-button-m
              class="mat-focus-indicator mat-flat-button mat-button-base button-cancel"
              style="margin-right: 15px"
              (click)="goBack()"
            >
              CANCEL
            </button>
          </div>

          <div class="sub-toolbar-cta-button">
            <button
              [disabled]="patternsSelected.selected.length <= 0"
              mat-raised-button
              pally-rounded-button-m
              class="button-cta"
              [ngClass]="
                patternsSelected.selected.length <= 0 ? 'button-disabled' : ''
              "
              (click)="startSimulation()"
            >
              <div style="display: flex; align-items: center; gap: 4px">
                NEXT <mat-icon>arrow_forward</mat-icon>
              </div>
            </button>
          </div>
        </div>
      </div>
    </mat-toolbar>
  </ng-container>
</ng-container>
